import { createAction } from "redux-actions";

import { moduleSlug } from "../../constants";

export const setHttpResponse = createAction(`${moduleSlug}/SET_HTTP_RESPONSE`);
export const setIsLoading = createAction(`${moduleSlug}/SET_IS_LOADING`);

export const requestConfigData = createAction(`${moduleSlug}/REQUEST_CONFIG_DATA`);
export const setConfigData = createAction(`${moduleSlug}/SET_CONFIG_DATA`);

export const setScrapeTask = createAction(`${moduleSlug}/SET_SCRAPE_TASK`);
